// RouteAddEditModal.stories.js

import React from 'react';
import RouteAddEditModal from './RouteAddEditModal';
import { generateComponentDocs, generateStoryDocs } from '../../../utils/documentationUtils';

export default {
  title: 'Components/Modals/RouteAddEditModal',
  component: RouteAddEditModal,
  decorators: [
    (Story) => (
      <div className="w-screen h-screen">
        <Story />
      </div>
    ),
  ],
  parameters: {
    ...generateComponentDocs(
      // What problem does it solve?
      '\nThe `RouteAddEditModal` component provides a reusable modal window for adding and editing routes.\n\n',
      // When & how to use it?
      `
Use the \`RouteAddEditModal\` component on the **Dashboard Page** by clicking the **"Plus"** icon, 
or on the **Routes Page** by clicking **"New Route"** to open the create-route form. 
Within a specific route, click **"Edit"** to open the edit-route form.
      `,
      // Current Usage
      `\nThe \`RouteAddEditModal\` component is used on the Dashboard and Routes pages. It displays details such as:
        \n- **Route Name**  
        \n- **Date**  
        \n- **Description**\n\n`,
      // Related Components
      `\n- **[DateSelectorV2](http://localhost:6006/?path=/docs/components-inputs-dateselectorv2--docs)**: A simple date picker.
      \n- **[TextInput](http://localhost:6006/?path=/docs/components-inputs-textinput--docs)**: Simple text input field for forms.\n\n`,
    ),
  },
  tags: ['autodocs'],
  argTypes: {
    onCloseModal: { action: 'handleClose' },
    onSubmit: { action: 'onSubmit' },
    data: { control: { type: 'object' } },
    title: { control: 'text' },
  },
};

const Template = (args) => <RouteAddEditModal {...args} />;

export const CreateRoute = Template.bind({});
CreateRoute.args = {
  title: 'Create Route',
  data: {
    name: '',
    date: '',
    description: '',
  },
};

CreateRoute.parameters = generateStoryDocs(
  // When is this variant used?
  '\nThis variant demonstrates the `RouteAddEditModal` component for creating a new route.\n\n',
  // Where is it currently used in the product?
  '\nThe `RouteAddEditModal` is available on the `Routes` page when clicking the `New Route` button, and on the `Dashboard` page when clicking the `"Plus"` icon.\n\n',
);

export const EditRoute = Template.bind({});
EditRoute.args = {
  title: 'Edit Route',
  data: {
    name: 'Route 66',
    date: '2025-02-21',
    description: 'This route covers key locations...',
  },
};

EditRoute.parameters = generateStoryDocs(
  // When is this variant used?
  '\nThis variant demonstrates the `RouteAddEditModal` component for editing the existing route.\n\n',
  // Where is it currently used in the product?
  '\nThe `RouteAddEditModal` is available on the `Routes` page when clicking the `Edit` button.\n\n',
);
